import { APIWithoutURLBaseAndAuth } from './API';

const path = `https://contador.impa.br`;

const urlBase = process.env.REACT_APP_PUBLIC_URL.replace('https://', '');

const ContadorService = {
    getDadosContagem: async () => await APIWithoutURLBaseAndAuth.list(`${path}/${urlBase}`),
}

export default ContadorService;